<template>
  <div class="org-scholars-list">
    <ul class="expert-list-header">
      <li>专家姓名</li>
      <li>职务</li>
      <li>研究领域</li>
      <li>产业创新指数</li>
      <li>成果数</li>
    </ul>

    <div
      class="expert-item"
      v-for="(scholar, index) in scholarsData"
      :key="index"
    >
      <div class="expert-inf">
        <div
          style="cursor: pointer"
          @click="goPersonalDetails(scholar.id)"
        >
          <el-avatar :size="46" :src="scholar.avatar" />
        </div>
        <div class="name-title">
          <h3 style="display: flex; white-space: nowrap; max-width: 230px">
            <b @click="goPersonalDetails(scholar.id)">{{
              scholar.name
            }}</b>
            <div
              class="title-item"
              v-for="(title, idx) in scholar.showTitle"
              :title="title"
              :key="idx"
            >
              {{ title }}
            </div>
          </h3>

          <p class="ellipsis">
            {{ scholar.org_name }}
          </p>
        </div>
      </div>
      <div class="all-font">{{ scholar.position || '-' }}</div>
      <div class="multiline-overflow">
        <span v-for="(interest, idx) in scholar.fields" :key="idx"
          >{{ interest.name }}；</span
        >
      </div>
      <div class="all-font">{{ scholar.innovation_index_l1 }}</div>
      <div class="all-font">{{ scholar.publications_count }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orgScholarsList',
  props: ['scholarsData'],
  data() {
    return {};
  },
  methods: {
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: {
            id: id,
          },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.org-scholars-list {
  .expert-list-header {
    display: flex;
    list-style: none;
    height: 40px;
    line-height: 40px;
    background-color: #f9fafb;
    border-bottom: 1px solid #eae9e9;
    margin-top: 12px;

    li {
      box-sizing: border-box;
      padding: 0 10px;
      font-size: 14px;
      color: #333333;
      font-weight: bold;
      border-right: 1px solid #eeeeee;

      &:nth-of-type(1) {
        width: 320px;
        text-align: left;
      }
      &:nth-of-type(2) {
        width: 100px;
      }

      &:nth-of-type(3) {
        width: 200px;
        text-align: left;
      }

      &:nth-of-type(4) {
        width: 150px;
      }
      &:nth-of-type(5) {
        width: 110px;
      }
    }
  }

  .expert-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    color: #333333;

    > div {
      box-sizing: border-box;
      padding: 10px;
      color: #333333;
      //border-right: 1px solid #EEEEEE;
      &:nth-of-type(1) {
        width: 320px;
        text-align: left;
      }
      &:nth-of-type(2) {
        width: 100px;
      }
      &:nth-of-type(3) {
        width: 200px;
        text-align: left;
        color: #0c78c1;
      }
      &:nth-of-type(4) {
        color: #c3a062;
        width: 150px;
      }
      &:nth-of-type(5) {
        width: 110px;
        color: #c3a062;
      }
    }

    .expert-inf {
      display: flex;
      align-items: center;

      > div.name-title {
        margin-left: 10px;
        h3 {
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          //min-width: 55px;

          b {
            float: left;
            font-size: 16px;
            color: #333333;
            max-width: 200px;
            cursor: pointer;

            &:hover {
              color: #0c78c1;
            }
          }

          p {
            display: inline-block;
            margin-bottom: 3px;
            color: #fe8b00;
            span {
              color: #0b4da2;
              font-size: 12px;
              font-weight: 400;
              padding: 4px 5px;
              border-radius: 4px;
              background: #e4efff;
              margin-left: 9px;
            }
          }
        }

        p {
          color: #666666;
          font-size: 13px;
          overflow: hidden;
          margin-top: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 227px;
        }
      }
    }
  }
}

.multiline-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-bottom: 0 !important;
  span {
    font-size: 14px;
    line-height: 24px;
    color: #344054;
  }
}
.title-item {
  color: #0b4da2;
  font-size: 12px;
  font-weight: 400;
  padding: 4px 5px;
  border-radius: 4px;
  background: #e4efff;
  margin-left: 9px;
  float: left;
}
.all-font {
  font-size: 14px;
}
</style>
